import { render, staticRenderFns } from "./ManageCompanyAnswers.vue?vue&type=template&id=b93012aa&scoped=true&"
import script from "./ManageCompanyAnswers.vue?vue&type=script&lang=js&"
export * from "./ManageCompanyAnswers.vue?vue&type=script&lang=js&"
import style0 from "./ManageCompanyAnswers.vue?vue&type=style&index=0&id=b93012aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93012aa",
  null
  
)

export default component.exports